import { render, staticRenderFns } from "./newpage2.vue?vue&type=template&id=706d23d6&scoped=true&"
import script from "./newpage2.vue?vue&type=script&lang=js&"
export * from "./newpage2.vue?vue&type=script&lang=js&"
import style0 from "./newpage2.vue?vue&type=style&index=0&id=706d23d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d23d6",
  null
  
)

export default component.exports